import React from 'react';
import PropTypes from 'prop-types';
import { Container, Title, HeaderContentContainer } from './header-content-list-css';

const HeaderContentList = ({ columns, contentBlocks }) => (
  <Container>
    {contentBlocks.map(({ header, children }) => (
      <HeaderContentContainer columns={columns} key={header}>
        <Title>{header}</Title>
        {children}
      </HeaderContentContainer>
    ))}
  </Container>
);

HeaderContentList.propTypes = {
  columns: PropTypes.number.isRequired,
  contentBlocks: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      content: PropTypes.object.isRequired,
    }),
  ).isRequired,
};

export default HeaderContentList;
